import { quickBoards, siteStats, tickerItems } from '@/mocks/home';

export default function Hero() {
  const tickerLoop = [...tickerItems, ...tickerItems];

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20editorial%20poster%20background%20with%20dark%20crimson%20and%20deep%20emerald%20ink%20swirls%2C%20crumpled%20paper%20texture%2C%20scattered%20geometric%20shards%2C%20moody%20shadow%20gradient%2C%20dramatic%20center%20lighting%2C%20cinematic%20depth%2C%20subtle%20film%20grain%2C%20high%20contrast%20artistic%20composition%2C%20no%20text&width=1920&height=1080&seq=gossip-hero-bg-01&orientation=landscape"
          alt="吃瓜黑料网 资源汇总 板块索引 视觉主图"
          title="吃瓜黑料网 资源汇总 板块索引"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative w-full pt-28 md:pt-36 pb-28 md:pb-32 px-4 md:px-8">
        <div className="w-full max-w-[1180px] mx-auto flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 text-background-100 text-xs md:text-sm animate-fade-up">
            <i className="ri-flashlight-line text-secondary-300"></i>
            全站资源汇总 · 每日多次更新 · 板块索引一页总览
          </span>

          <h1 className="mt-6 font-heading font-black text-background-50 text-4xl md:text-6xl tracking-wide animate-fade-up">
            吃瓜黑料网
          </h1>

          <p className="mt-5 max-w-3xl text-background-100 text-sm md:text-lg leading-relaxed animate-fade-up">
            资源汇总页，聚合全站爆料板块与内容索引，热门事件、人物黑料、瓜料分类一页总览。快速定位你关注的板块，随时跟进最新更新，吃瓜不迷路。
          </p>

          <div className="mt-9 w-full max-w-2xl flex flex-col sm:flex-row items-stretch gap-3 animate-fade-up">
            <div className="flex-1 flex items-center gap-3 h-14 px-4 rounded-lg bg-background-50/95 border border-background-50/40 text-foreground-500">
              <i className="ri-search-2-line text-lg"></i>
              <input
                type="text"
                placeholder="输入板块、事件或关键词，快速定位索引"
                className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
              />
            </div>
            <button
              type="button"
              className="h-14 px-7 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索板块
            </button>
          </div>

          <div className="mt-6 flex flex-wrap justify-center gap-2 md:gap-3 animate-fade-up">
            {quickBoards.map((board) => (
              <a
                key={board.id}
                href="#board-index"
                className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-background-50/25 bg-background-50/10 text-background-100 hover:bg-background-50/20 hover:text-background-50 text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className={`${board.icon} text-secondary-300`}></i>
                {board.name}
              </a>
            ))}
          </div>

          <div className="mt-11 w-full grid grid-cols-2 md:grid-cols-4 gap-y-6 md:gap-y-0 border-t border-background-50/20 pt-7 animate-fade-up">
            {siteStats.map((stat, index) => (
              <div
                key={stat.id}
                className={`flex flex-col items-center gap-2 ${
                  index !== siteStats.length - 1 ? 'md:border-r md:border-background-50/20' : ''
                }`}
              >
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                  {stat.value}
                  <span className="text-base md:text-lg text-secondary-300 ml-1">{stat.unit}</span>
                </span>
                <span className="text-xs md:text-sm text-background-200">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 h-12 bg-foreground-950/85 backdrop-blur flex items-center overflow-hidden">
        <div className="flex items-center gap-2 shrink-0 h-full px-4 md:px-8 bg-primary-500 text-background-50 relative z-10">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-live-line text-sm animate-pulse-soft"></i>
          </span>
          <span className="text-xs md:text-sm font-medium whitespace-nowrap">实时快讯</span>
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker">
            {tickerLoop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="text-background-200 text-xs md:text-sm px-8 whitespace-nowrap border-r border-background-50/10"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}